import { SrIcon } from "@/components/ui/SrIcon";
import type { WorkspaceBranch } from "@/lib/tilbudsarbeidsrom/branches";

const COPY: Partial<Record<WorkspaceBranch, { icon: string; title: string; body: string }>> = {
  presentasjon: {
    icon: "presentation",
    title: "Presentasjon kommer",
    body: "Her kommer presentasjonen til kundemøtet, med lysbilder fra Sølvrevs maler og budsjettet hentet rett fra tilbudet.",
  },
  tilbud: {
    icon: "file-text",
    title: "Tilbud kommer",
    body: "Her kommer tilbudet kunden leser på nett, med egen lenke per mottaker og oversikt over hva kunden har lest.",
  },
};

/** Tom tilstand for grener som ennå ikke er bygget. */
export function UpcomingBranch({ branch }: { branch: WorkspaceBranch }) {
  const copy = COPY[branch];
  if (!copy) return null;
  return (
    <div className="border-[1.5px] border-dashed border-foreground/30 px-6 py-12 flex flex-col items-center text-center gap-3">
      <SrIcon name={copy.icon} className="w-6 h-6 text-muted-foreground" />
      <h2 className="font-display text-lg">{copy.title}</h2>
      <p className="text-sm text-muted-foreground max-w-md">{copy.body}</p>
    </div>
  );
}
